import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import moment from 'moment';

import Moment = moment.Moment;

@Component({
  selector: 'app-day-datepicker',
  templateUrl: 'day-datepicker.component.html',
  styleUrls: ['day-datepicker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DayDatepickerComponent implements OnInit {
  private _minDate: string;
  get minDate(): string {
    return this._minDate;
  }
  @Input() set minDate(value: string) {
    if (value) {
      this._minDate = value;
    }
  }

  private _maxDate: string = moment().toISOString();
  get maxDate(): string {
    return this._maxDate;
  }
  @Input() set maxDate(value: string) {
    if (value) {
      this._maxDate = value;
    } else {
      this._maxDate = undefined;
    }
  }

  @Input() navigationArrows = true;

  datepickerDate = new FormControl<moment.Moment>(moment());
  @Output() dateChanged = new EventEmitter<Moment>();

  ngOnInit(): void {
    this.resetDate();
  }

  resetDate(): void {
    this.datepickerDate.setValue(moment());
  }

  onDateChange(event: MatDatepickerInputEvent<Moment>): void {
    this.datepickerDate.setValue(event.value);
    this.dateChanged.emit(this.datepickerDate.value);
  }

  canSelectNextDay(): boolean {
    if (this.maxDate) {
      const nextDayDate = moment(this.datepickerDate.value).startOf('day').add(1, 'd');
      const isAfterMaxDate = moment(nextDayDate).isAfter(moment(this.maxDate).startOf('day'));

      return !isAfterMaxDate;
    } else {
      return true;
    }
  }

  canSelectPreviousDay(): boolean {
    if (this.minDate) {
      const previousDayDate = moment(this.datepickerDate.value).startOf('day').subtract(1, 'd');
      const isBeforeMinDate = moment(previousDayDate).isBefore(moment(this.minDate).startOf('day'));

      return !isBeforeMinDate;
    } else {
      return true;
    }
  }

  onNextDay(): void {
    if (this.canSelectNextDay()) {
      const nextDayDate = moment(this.datepickerDate.value).add(1, 'd');
      this.datepickerDate.setValue(nextDayDate);
      this.dateChanged.emit(this.datepickerDate.value);
    }
  }

  onPreviousDay(): void {
    if (this.canSelectPreviousDay()) {
      const previousDayDate = moment(this.datepickerDate.value).subtract(1, 'd');
      this.datepickerDate.setValue(previousDayDate);
      this.dateChanged.emit(this.datepickerDate.value);
    }
  }
}
